import { useGetAccounts } from '@vindr/services/actions/account.action';
import { ColumnType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';

const creatorColumn = ({
  title,
  dataIndex = 'creator_id',
  width = 50,
  key = 'creator_id',
  ...props
}: ColumnType<any> = {}) => {
  const { t } = useTranslation('Vindoc');
  title = title || t('Creator');

  return {
    title: title,
    dataIndex,
    width,
    key,
    render: (text) => <RowComp text={text} />,
    ...props,
  };
};

const RowComp = ({ text }: { text: string }) => {
  const response = useGetAccounts({ limit: 10, offset: 0, ids: [text] });
  const creator = response?.data?.data?.[0];

  return <span>{creator?.fullname || creator?.username || '-'}</span>;
};

export default creatorColumn;
